import { Component, Input } from "@angular/core";
import { MatListModule } from '@angular/material/list';
import { TranslatePipe } from "@ngx-translate/core";
import { MatIconModule } from "@angular/material/icon";
import { NgIf } from "@angular/common";
import { LoadingComponent } from "../loading/loading.component";
import { PAGE_ROUTES, SESSION_KEY_NAME } from "../../constants";
import { Router } from "@angular/router";
import { AccountOption } from "../../services/auth.service";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-account-selection-list",
  imports: [MatListModule, MatIconModule, TranslatePipe, LoadingComponent, NgIf],
  standalone: true,
  templateUrl: "./account-selection-list.component.html",
  styleUrl: "./account-selection-list.component.scss"
})
export class AccountSelectionListComponent {
  @Input() accounts: AccountOption[] = [];
  @Input() accessToken = "";
  @Input() sessionId = "";
  @Input() loginHint = "";

  protected isLoading = false;

  constructor(private _router: Router) {}

  onSelect(account: AccountOption) {
    const redirectUri = account.appTypeId === 1
      ? `${environment.adminRedirectUri}/#/login`
      : `${environment.defaultRedirectUri}/login`;

    if (this.loginHint) {
      localStorage.setItem(SESSION_KEY_NAME.WORKOS.previous_session_login_hint, this.loginHint);
    }
    if (this.sessionId) {
      localStorage.setItem(SESSION_KEY_NAME.WORKOS.session_id, this.sessionId);
    }

    const queryParams = {
      accessToken: this.accessToken,
      redirectUri,
      sessionId: this.sessionId
    };

    this._router.navigate([PAGE_ROUTES.SUCCESS], { queryParams });
  }
}
